import role7Schema from '../../../../assets/forms/role-130000.form.json';
import { SHEET_KEYS } from '../../../models/sheet-keys';
import { ConditionalControl } from '../conditional/conditional-field.model';
import { makeSchemaProjector } from './make-schema-projector';

/**
 * Strips role 7's conditionally hidden fields at submit (3 cross-sheet `hideWhen`
 * fields gated by filing-info TypeOfSubmission; 2 same-sheet `requiredIf` fields).
 * Reads the schema's `conditional` blocks via the shared evaluator — same source
 * the component renders from.
 */
export const role7AuditorsReportProjector = makeSchemaProjector(
  SHEET_KEYS.auditorsReport,
  (role7Schema as { controls: ConditionalControl[] }).controls
);
